module.exports = __webpack_public_path__ + "static/img/bg-es.ff772c4d.png";